import { GET_DOWNLOAD_URLS, GET_PRESIGNED_URL } from '../../endpoints';
import makeAuthenticatedRequest from '../base-api';

interface PresignedUrlResponse {
  url: string;
}

export const getPresignedUrl = async (
  useCase: string,
  assetKey: string
): Promise<PresignedUrlResponse> => {
  const response = await makeAuthenticatedRequest(
    GET_PRESIGNED_URL(useCase, assetKey),
    {
      method: 'GET',
    }
  );

  if (!response.ok) {
    throw new Error('Failed to get presigned url');
  }

  const data = await response.json();
  return data.data;
};

export const getDownloadUrls = async (keys: string[]) => {
  const response = await makeAuthenticatedRequest(GET_DOWNLOAD_URLS(keys), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ keys }),
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || 'Failed to get download urls');
  }
  return data.data;
};

export const uploadFileToS3 = async (
  url: string,
  file: File
): Promise<void> => {
  try {
    const response = await fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': file.type,
      },
      body: file,
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(
        `Failed to upload file to S3: ${response.status} ${response.statusText} - ${errorText}`
      );
    }
  } catch (error) {
    console.error('Upload error:', error);
    throw error;
  }
};

export const uploadAsset = async (
  file: File,
  useCase: string,
  assetType: string
): Promise<string> => {
  const assetKey = `${assetType}/${Date.now().toString()}-${file.name}`;

  const { url } = await getPresignedUrl(useCase, assetKey);
  await uploadFileToS3(url, file);

  return assetKey;
};

// Get a single download URL for a file
export const getDownloadUrl = async (key: string): Promise<string> => {
  const { urls } = await getDownloadUrls([key]);
  return urls[0];
};
